import store from '../StoreConfig';

const tnk = {
get() {
    const state = store.getState();
    const token = state.login.user.accessToken;
    return token 
  }
}
export default tnk